import React from "react"
import { Link } from "react-router-dom"

export default React.forwardRef((itemProps, ref) => (
  <Link {...itemProps} innerRef={ref} />
))
